export const minifyJSON = (inputData) => {
  try {
    return { minified: JSON.stringify(JSON.parse(inputData), null, 0), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JSON input.', isError: true };
  }
};

export const minifyXML = (inputData) => {
  try {
    return { minified: inputData.replace(/\s+/g, ' ').trim(), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid XML input.', isError: true };
  }
};

export const minifyHTML = (inputData) => {
  try {
    return { minified: inputData.replace(/\s+/g, ' ').trim(), isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid HTML input.', isError: true };
  }
};

export const minifyCSS = (inputData) => {
    try {
        const minified = inputData
            .replace(/\/\*[\s\S]*?\*\//g, '')     
            .replace(/\s*{\s*/g, '{')
            .replace(/\s*}\s*/g, '}')
            .replace(/\s*;\s*/g, ';')
            .replace(/\s*:\s*/g, ':')
            .replace(/\s*,\s*/g, ',')
            .replace(/\s+/g, ' ')                 
            .replace(/\n/g, '')                   
            .trim();
        return { minified, isError: false };
    } catch (error) {
        return { minified: 'Error: Invalid CSS input.', isError: true };
    }
};

export const minifyJs = (inputData) => {
  try {
    const minified = inputData
      .replace(/\/\/.*(?=[\n\r])/g, '')            
      .replace(/\/\*[\s\S]*?\*\//g, '')            
      .replace(/\s*([{};:,+<>=!&|()\[\]])\s*/g, '$1') 
      .replace(/\n+/g, '')                         
      .replace(/\s{2,}/g, ' ')                     
      .trim();
    return { minified, isError: false };
  } catch (error) {
    return { minified: 'Error: Invalid JavaScript input.', isError: true };
  }
};

// TypeScriptMinifier.js
export const minifyTypeScript = (tsCode) => {
  try {
    if (!tsCode) return { convertedData: '', isError: false };

    // Simple minification: remove newlines, extra spaces, and comments
    let minified = tsCode
      .replace(/\/\/.*$/gm, '') // remove single-line comments
      .replace(/\/\*[\s\S]*?\*\//g, '') // remove block comments
      .replace(/\s+/g, ' ') // collapse whitespace
      .replace(/\s*([{};,:])\s*/g, '$1') // remove spaces around symbols
      .trim();

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid TypeScript code', isError: true };
  }
};

// SqlMinifier.js
export const minifySQL = (sqlCode) => {
  try {
    if (!sqlCode) return { convertedData: '', isError: false };

    // Remove comments, extra spaces, and newlines
    let minified = sqlCode
      .replace(/--.*$/gm, '') // remove single-line comments
      .replace(/\/\*[\s\S]*?\*\//g, '') // remove block comments
      .replace(/\s+/g, ' ') // collapse whitespace
      .replace(/\s*([(),;])\s*/g, '$1') // remove spaces around symbols
      .trim();

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid SQL code', isError: true };
  }
};

// YamlMinifier.js
export const minifyYAML = (yamlCode) => {
  try {
    if (!yamlCode) return { convertedData: '', isError: false };

    // Remove comments and empty lines, collapse spaces
    let minified = yamlCode
      .replace(/#.*$/gm, '') // remove comments
      .split('\n')
      .map(line => line.trim())
      .filter(line => line) // remove empty lines
      .join('\n');

    return { convertedData: minified, isError: false };
  } catch (err) {
    return { convertedData: 'Error: Invalid YAML', isError: true };
  }
};
